/** Navigation context by opaque handle: the URL points at it, the session authorizes it. */

const STORAGE_PREFIX = 'navctx:';
export const HANDLE_PARAM = 'ctx';

function newHandle() {
  const bytes = new Uint8Array(9);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(36).padStart(2, '0')).join('');
}

/** Anything but a positive integer id would travel straight into a payload. */
function readEntry(handle, ownerId) {
  if (!handle || !ownerId) return null;

  try {
    const raw = sessionStorage.getItem(STORAGE_PREFIX + handle);
    if (!raw) return null;

    const entry = JSON.parse(raw);
    if (String(entry?.ownerId) !== String(ownerId)) return null;

    const id = Number(entry.id);
    if (!Number.isInteger(id) || id <= 0) return null;

    return { id, label: typeof entry.label === 'string' ? entry.label : null };
  } catch {
    return null;
  }
}

/** Answers with the handle; without it in the address bar the entry is unreachable. */
export function openContext({ id, label, ownerId }) {
  if (!id || !ownerId) return null;

  const handle = newHandle();

  try {
    sessionStorage.setItem(STORAGE_PREFIX + handle, JSON.stringify({
      id, label: label ?? null, ownerId,
    }));
  } catch {
    return null; // storage unavailable: the screen falls back to asking
  }

  return handle;
}

export function resolveContext({ handle, ownerId }) {
  return readEntry(handle, ownerId);
}

/** A session ending takes every context with it — none of them outlive their owner. */
export function dropAllContexts() {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(STORAGE_PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // storage unavailable
  }
}
